import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MetaData from "./layouts/MetaData";
import {
  HOME_URL,
  CONTACT_URL,
  removePrefixFromURL,
} from "../constants/commonConstants";
import { Link } from "react-router-dom";
import ModalBooking from "../pages/layouts/ModalBooking";
import {
  clearErrors,
  getFeaturePackages,
  getViewCategory,
  getHotDeals,
} from "../action/packagesActions";
import HomeBannerSlider from "./HomeBannerSlider";

function Home() {
  const getBackgroundImage = () => {
    return window.innerWidth <= 768
      ? "/assets/images/mobile_version.png"
      : "/assets/images/Golden_visa.png";
  };

  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [ModalQuery, setModalQuery] = useState("");
  const { packages, error } = useSelector((state) => state.packages);
  const { packagesHot } = useSelector((state) => state.packagesHot);
  const [backgroundImage, setBackgroundImage] = useState(getBackgroundImage());
  console.log(backgroundImage);
  useEffect(() => {
    if (error) {
      alert.error(error);
      dispatch(clearErrors());
    }
    dispatch(getFeaturePackages());
    dispatch(getHotDeals());
  }, [dispatch, error]);

  useEffect(() => {
    const handleResize = () => {
      setBackgroundImage(getBackgroundImage());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { viewcategory } = useSelector((state) => state.viewcategory);

  useEffect(() => {
    dispatch(getViewCategory(6));
  }, [dispatch]);

  const handleOpenModal = (name) => {
    setModalQuery(name);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <Fragment>
      <MetaData title={`Home`} />
      {showModal && (
        <ModalBooking
          message={`Query Related for ${ModalQuery}`}
          show={showModal}
          handleClose={handleCloseModal}
        />
      )}
      <main id="content" className="site-main">
        <HomeBannerSlider />
        <section className="home-destination pd-top">
          <div className="container">
            <div className="destination-section">
              <div className="col-md-12">
                <Link onClick={() => handleOpenModal("Golden Visa")}>
                  <figure class="career-detail-image">
                    <img src={backgroundImage} />
                  </figure>
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="home-destination pd-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 offset-lg-2 text-sm-center">
                <div className="section-heading">
                  <h2 className="section-title">HOT DEALS</h2>
                </div>
              </div>
            </div>
            <div className="destination-section">
              <div className="row">
                {packagesHot &&
                  packagesHot.map((tour, index) => (
                    <div className="col-lg-4 col-md-6" key={index}>
                      <Link to={`/tour/${tour.slug}`}>
                        <article
                          className="destination-item"
                          style={{
                            backgroundImage: `url(${removePrefixFromURL(
                              tour.mainImage
                            )})`,
                          }}
                        >
                          <div className="destination-content">
                            <div className="rating-start-wrap">
                              <div className="rating-start">
                                <span style={{ width: "100%" }}></span>
                              </div>
                            </div>
                            <h3>{tour.name}</h3>
                          </div>
                        </article>
                      </Link>
                    </div>
                  ))}
              </div>
              <div className="section-btn-wrap text-center">
                <Link to={`package/hot-deals`} className="round-btn">
                  More Deals
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="home-destination pd-top">
          <div className="container">
            <div className="row">
              <div className="col-lg-8 offset-lg-2 text-sm-center">
                <div className="section-heading">
                  <h5 className="sub-title">UNCOVER PLACE</h5>
                  <h2 className="section-title">POPULAR DESTINATION</h2>
                </div>
              </div>
            </div>
            <div className="destination-section">
              <div className="row">
                {packages &&
                  packages.map((tour, index) => (
                    <div className="col-lg-4 col-md-6" key={index}>
                      <Link to={`/tour/${tour.slug}`}>
                        <article
                          className="destination-item"
                          style={{
                            backgroundImage: `url(${removePrefixFromURL(
                              tour.mainImage
                            )})`,
                          }}
                        >
                          <div className="destination-content">
                            <div className="rating-start-wrap">
                              <div className="rating-start">
                                <span style={{ width: "100%" }}></span>
                              </div>
                            </div>
                            <h3>{tour.name}</h3>
                          </div>
                        </article>
                      </Link>
                    </div>
                  ))}
              </div>
              <div className="section-btn-wrap text-center">
                <Link to={`package/uae-packages`} className="round-btn">
                  More Destination
                </Link>
              </div>
            </div>
          </div>
        </section>
        <section className="home-destination pd-top">
          <div className="home-counter">
            <div className="container">
              <div className="counter-wrap">
                <div className="counter-item">
                  <span className="counter-no">
                    <span className="counter">16</span>K+
                  </span>
                  <span className="counter-desc">SATISFIED CUSTOMER</span>
                </div>
                <div className="counter-item">
                  <span className="counter-no">
                    <span className="counter">5600</span>+
                  </span>
                  <span className="counter-desc">TICKET BOOKED</span>
                </div>
                <div className="counter-item">
                  <span className="counter-no">
                    <span className="counter">1500</span>+
                  </span>
                  <span className="counter-desc">VISA ISSUED</span>
                </div>
                <div className="counter-item">
                  <span className="counter-no">
                    <span className="counter">220</span>+
                  </span>
                  <span className="counter-desc">TOUR DESTINATION</span>
                </div>
              </div>
            </div>
          </div>
        </section>
        {viewcategory && (
          <section className="home-destination pd-top">
            <div className="home-counter">
              <div className="container">
                <div className="row">
                  {viewcategory.map((vc, index) => (
                    <div className="col-md-6" key={index}>
                      <article
                        className="offer-item"
                        style={{
                          backgroundImage: `url(${removePrefixFromURL(
                            vc.mainImage
                          )})`,
                        }}
                      >
                        <div className="offer-content">
                          <h3>{vc.name}</h3>
                          <Link
                            onClick={() => handleOpenModal(vc.name)}
                            className="round-btn"
                          >
                            Book Now
                          </Link>
                        </div>
                      </article>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        )}
        <section className="home-callback bg-color-callback primary-bg">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="section-title">
                  READY FOR UNFORGATABLE TRAVEL. CONTACT US!
                </h2>
              </div>
              <div className="col-md-4 text-md-end">
                <Link
                  to={CONTACT_URL}
                  className="outline-btn outline-btn-white"
                >
                  Contact Us!
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    </Fragment>
  );
}

export default Home;
